<template>
  <div class="kw_tree" v-loading="loading">
    <div class="treeBox">
      <div v-if="(newTreeData)" v-for="(firsTree,index) in newTreeData" :key="'first_'+index">
        <div class="treeListBox" :style="pageSetInfo.listStyleSet.listPageTreeTitleStyleSet?pageSetInfo.listStyleSet.listPageTreeOutermostBoxStyleSet.styleSetCode:''" kwName="listPageTreeOutermostBoxStyleSet">
          <div class="treeList" :style="pageSetInfo.listStyleSet.listPageTreeTitleStyleSet?pageSetInfo.listStyleSet.listPageTreeListBoxStyleSet.styleSetCode:''" kwName="listPageTreeListBoxStyleSet">
            <div class="treeTitle" :style="pageSetInfo.listStyleSet.listPageTreeTitleStyleSet?pageSetInfo.listStyleSet.listPageTreeTitleStyleSet.styleSetCode:''" kwName="listPageTreeTitleStyleSet"><span>{{index+1}}</span>{{firsTree.NAME}}</div>
            <div>
              <div v-if="firsTree.STUDY_DATE" class="treeListItem" :style="pageSetInfo.listStyleSet.listPageTreeFirstStyleSet?pageSetInfo.listStyleSet.listPageTreeFirstStyleSet.styleSetCode:''" kwName="listPageTreeFirstStyleSet">
                <i v-if="(firsTree.TYPE_ICON)" :class="firsTree.TYPE_ICON"></i>
                <span>直播</span><span>{{firsTree.STUDY_DATE}}</span>
                <div v-if="(pageSetInfo.operaButtonSet.length>0 && pageSetInfo.operaButtonSetIfHide)">      
                  <kw_btn_array :pageSetInfo="(pageSetInfo)" :dataInfo="(firsTree)" :dataIndex="(firsTree.list_index)" @dataButtonClick="dataButtonClick"  :isLimitButton="isLimitButton"></kw_btn_array>
                </div>
              </div>
              <div v-for="(secondTree,scondIndex) in firsTree.children" :key="scondIndex"> 
                <div class="treeListItem" :style="pageSetInfo.listStyleSet.listPageTreeLoopStyleSet?pageSetInfo.listStyleSet.listPageTreeLoopStyleSet.styleSetCode:''" kwName="listPageTreeLoopStyleSet">
                  <i v-if="(secondTree.TYPE_ICON)" :class="secondTree.TYPE_ICON"></i>
                  <span>{{secondTree.NAME}}</span><span>{{secondTree.STUDY_DATE}}</span>
                  <div v-if="(pageSetInfo.operaButtonSet.length>0 && pageSetInfo.operaButtonSetIfHide)">      
                    <kw_btn_array :pageSetInfo="(pageSetInfo)" :dataInfo="(secondTree)" :dataIndex="(secondTree.list_index)" @dataButtonClick="dataButtonClick" :isLimitButton="isLimitButton"></kw_btn_array>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';

// 列表的按钮组件
import kw_btn_array from '@/components/look/kw_btn_array.vue';

export default {
  name: 'kw_tree',
  props: {
    pageSetInfo: {
      type: Object,
      value: {}
    },
    //树的数据内容
    treeData: {
      type: Array,
      value: []
    },
    treeIndex: {
      type: Number,
      value: 1
    },
    //如果是 提供了页面等信息则 在树组件中去获取数据
    initParam: {
      type: Object,
      value: null
    },
    //传入的数据为列表数据 需要进行数据处理
    dataList: {
      type: Array,
      value: null
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading:false,
      newTreeData:[]
    };
  },
  created() {
    this.initAttached();
  },
  mounted() {
    
  },
  watch:{
    dataList(){
      this.initAttached();
    }
  },
  computed:{
  },
  components: {
    kw_btn_array
  },
  methods: {
    initAttached:function(){
      if (this.initParam) {
        this.loadCourseOutLine();
      }
      if (this.dataList) {
        var outLineArr = pageUtils.buildTree(this.dataList);
        this.newTreeData = outLineArr;
      } else {
        this.newTreeData = treeData;
      }
    },
    /**
   * 加载课程知识体系信息
   */
    loadCourseOutLine: function () {
      var that = this;
      var initParam = this.initParam;
      var toHtData = {};
      var mainTableId = initParam.mainTableId;
      var mainPageId = initParam.mainPageId;
      var tableId = initParam.tableId;
      var pageId = initParam.pageId;
      var nowDataId = initParam.mainId;
      toHtData.tableId = tableId;
      toHtData.pageId = pageId;
      toHtData.mainTableId = mainTableId;
      toHtData.mainPageId = mainPageId;
      if (nowDataId > 0) {
        toHtData.mainId = nowDataId;
        //toHtData.source = app.globalData.source;
        toHtData.sessionId = app.globalData.sessionId;
        toHtData.ifTree = 1;
        that.loading = true;
        //根据pageId获取列表页面的设置信息 获取列表页面的数据信息
        utils.request(that,{
          url: 'model_ajaxList.do',
          data: toHtData,
          success: function (res) {
            that.loading = false;
            if (res.data != null) {
              // console.info("toAddData=====", res.data);
              var dataArr = res.data.rows;
              var outLineArr = utils.buildTree(dataArr);
              // console.info("outLineArr=====", outLineArr);
              that.treeData = outLineArr;
            }
          }
        })
      }
    },
    /**
     * 列表按钮点击事件
     */
    dataButtonClick: function (detail,dataInfo) {
      pageUtils.dataButtonClick(this,detail,dataInfo);
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.treeBox{background: #ffffff}
.treeListBox{border-bottom: 1px solid #F3F3F3}
.treeList{padding: 20px 25px}
.treeTitle{font-size: 14px;color: #484848;font-weight: bold;padding: 8px 0}
.treeTitle span{background: #EDEDEF;display: inline-block;font-weight: normal;font-size: 12px;border-radius: 18px;width: 18px;height: 18px;text-align: center;line-height: 18px;margin-right: 5px}
.treeListItem{font-size: 14px;color: #6F6F6F;display: flex;justify-content: space-between;padding: 5px 0;}
</style>
